(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-lp-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ── Countdown ────────────────────────────────────────────────────────────
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      return isNaN(t) ? null : t;
    }

    function tick(timer, lastDays) {
      var delta = timer._slTarget - Date.now();

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;
      var sl = timer._slSlots;

      if (sl.days) sl.days.textContent = pad(days);
      if (sl.hrs) sl.hrs.textContent = pad(hrs);
      if (sl.min) sl.min.textContent = pad(min);
      if (sl.sec) sl.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var d = timer.dataset;
        timer._slSr.textContent =
          days +
          ' ' +
          (d.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (d.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (d.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (d.labelSec || 'seconds') +
          ' remaining';
      }

      return days;
    }

    function initCountdown(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      timer._slSlots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrapCountdowns() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) initCountdown(nodes[i]);
    }

    // ── Geo-gate ─────────────────────────────────────────────────────────────
    // Hides sections with [data-sl-geo-gate] for visitors outside the target
    // state. Uses ipapi.co (free tier: 1k req/day per IP). sessionStorage cache
    // (1 h TTL) keeps most sessions to a single request. Fails open on error.
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour

    function applyDiscount(code) {
      if (!code || !code.trim()) return;
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {});
    }

    function applyGeo(sections, region) {
      for (var i = 0; i < sections.length; i++) {
        var target = sections[i].getAttribute('data-sl-geo-target') || 'California';
        var result = region === target ? 'pass' : 'fail';
        console.log(
          '[SL GeoGate] section:',
          sections[i].id || sections[i].className,
          '| region:',
          region,
          '| target:',
          target,
          '| result:',
          result
        );
        sections[i].setAttribute('data-sl-geo', result);
        if (result === 'pass') {
          var code = sections[i].getAttribute('data-sl-discount') || '';
          applyDiscount(code);
        }
      }
    }

    function revealAll(sections) {
      console.log('[SL GeoGate] ⚠️ Failing open — revealing all geo-gated sections');
      for (var i = 0; i < sections.length; i++) {
        sections[i].setAttribute('data-sl-geo', 'pass');
      }
    }

    function runGeoGate() {
      var sections = document.querySelectorAll('[data-sl-geo-gate]');
      console.log('[SL GeoGate] found', sections.length, 'geo-gated section(s)');
      if (!sections.length) return;

      try {
        var raw = sessionStorage.getItem(GEO_CACHE_KEY);
        if (raw) {
          var cached = JSON.parse(raw);
          var age = Math.round((Date.now() - cached.ts) / 1000);
          var valid = Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string';
          console.log('[SL GeoGate] cache hit — region:', cached.region, '| age:', age + 's', '| valid:', valid);
          if (valid) {
            applyGeo(sections, cached.region);
            return;
          }
          console.log('[SL GeoGate] cache expired — re-fetching ipapi.co');
        } else {
          console.log('[SL GeoGate] no cache — fetching ipapi.co');
        }
      } catch (e) {
        console.warn('[SL GeoGate] cache read error:', e);
      }

      fetch('https://ipapi.co/json/')
        .then(function (r) {
          if (!r.ok) throw new Error('geo ' + r.status);
          return r.json();
        })
        .then(function (data) {
          console.log('[SL GeoGate] ipapi.co response:', {
            ip: data.ip,
            country: data.country_name,
            region: data.region,
            city: data.city,
          });
          var region = typeof data.region === 'string' ? data.region : '';
          try {
            sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
          } catch (e) {}
          applyGeo(sections, region);
        })
        .catch(function (err) {
          console.warn('[SL GeoGate] ipapi.co fetch failed:', err, '— failing open');
          revealAll(sections); // fail open
        });
    }

    // ── Bootstrap ────────────────────────────────────────────────────────────
    function bootstrap() {
      bootstrapCountdowns();
      runGeoGate();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    document.addEventListener('shopify:section:load', bootstrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-lp-products-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ---------------------------------------------------------------------------
    // Fetch coalescer — runs once per page.
    // SavedBy, Intelligems, and Rebuy all call GET /cart.js simultaneously after
    // a cart add, triggering Shopify's 429 rate limit. We patch window.fetch to
    // collapse concurrent /cart.js GET requests into a single real network call
    // and return cloned responses to every caller.
    // ---------------------------------------------------------------------------
    if (!window.__slCartFetchPatched) {
      window.__slCartFetchPatched = true;
      var _origFetch = window.fetch;
      var _coalesceTimer = null;
      var _coalescePending = [];
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && typeof input.url === 'string' ? input.url : '';
        var method = (init && init.method ? init.method : 'GET').toUpperCase();
        // Only coalesce GET /cart.js (with or without cache-busting query params)
        if (method === 'GET' && /^\/cart\.js(\?|$)/.test(url)) {
          return new Promise(function (resolve, reject) {
            _coalescePending.push({ resolve: resolve, reject: reject });
            clearTimeout(_coalesceTimer);
            _coalesceTimer = setTimeout(function () {
              var pending = _coalescePending.splice(0);
              _origFetch
                .call(window, '/cart.js', {
                  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  credentials: 'same-origin',
                })
                .then(function (response) {
                  // Each caller needs its own Response to read the body independently.
                  // response.clone() is safe here — no body has been consumed yet.
                  pending.forEach(function (p, i) {
                    p.resolve(i < pending.length - 1 ? response.clone() : response);
                  });
                })
                .catch(function (err) {
                  pending.forEach(function (p) {
                    p.reject(err);
                  });
                });
            }, 80); // 80 ms window catches all simultaneous calls
          });
        }
        return _origFetch.apply(this, arguments);
      };
    }

    var ROOT_SELECTOR = '[data-sl-id="sl-section-lp-products-grid-v1"]';
    function moneyFormat(cents) {
      // Use Shopify.formatMoney if present; otherwise format as $X.XX
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
        }
      } catch (e) {
        /* fall through */
      }
      var n = (Number(cents) || 0) / 100;
      return '$' + n.toFixed(2);
    }
    function $(sel, root) {
      return (root || document).querySelector(sel);
    }
    function $$(sel, root) {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function initSection(section) {
      if (!section || section.dataset.lpGridInit === '1') return;
      section.dataset.lpGridInit = '1';

      // Note: cart-drawer suppression on ATC is handled by quick-add-soul.js
      // via the data-suppress-cart-drawer attribute. We intentionally do NOT
      // patch cart-drawer.open() here so the cart icon still opens the drawer.

      var scroller = section.querySelector('[data-lp-grid-scroller]');
      var trackFill = section.querySelector('[data-lp-grid-track-fill]');
      var track = section.querySelector('[data-lp-grid-track]');
      var prevBtn = section.querySelector('[data-lp-grid-prev]');
      var nextBtn = section.querySelector('[data-lp-grid-next]');
      var cartCountEl = section.querySelector('[data-lp-grid-cart-count]');
      var cartTotalEl = section.querySelector('[data-lp-grid-cart-total]');

      // --- Carousel ---
      function updateProgress() {
        if (!scroller || !trackFill) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var pct = max > 0 ? (scroller.scrollLeft / max) * 100 : 0;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        trackFill.style.width = pct + '%';
        if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));
        if (prevBtn) prevBtn.setAttribute('aria-disabled', pct <= 0.5 ? 'true' : 'false');
        if (nextBtn) nextBtn.setAttribute('aria-disabled', pct >= 99.5 ? 'true' : 'false');
      }
      function scrollToPage(dir) {
        if (!scroller) return;
        var items = Array.prototype.slice.call(scroller.querySelectorAll('.c-lp-products-grid__item'));
        if (!items.length) return;
        // Cards-per-view from computed width
        var itemWidth = items[0].getBoundingClientRect().width;
        var perPage = Math.max(1, Math.round(scroller.clientWidth / itemWidth));
        // Find the first item closest to current scrollLeft (start of current page)
        var current = scroller.scrollLeft;
        var firstIdx = 0;
        var minDiff = Infinity;
        items.forEach(function (item, i) {
          var diff = Math.abs(item.offsetLeft - current);
          if (diff < minDiff) {
            minDiff = diff;
            firstIdx = i;
          }
        });
        var targetIdx = Math.max(0, Math.min(items.length - 1, firstIdx + dir * perPage));
        scroller.scrollTo({ left: items[targetIdx].offsetLeft, behavior: 'smooth' });
      }
      if (scroller) {
        scroller.addEventListener('scroll', updateProgress, { passive: true });
        // scrollend fires once snapping settles (supported in modern browsers)
        scroller.addEventListener('scrollend', updateProgress, { passive: true });
        window.addEventListener('resize', function () {
          // Re-measure after resize so progress reflects new layout
          requestAnimationFrame(updateProgress);
        });
        // Defer initial paint so CSS grid has been laid out
        requestAnimationFrame(function () {
          requestAnimationFrame(updateProgress);
        });
      }
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          scrollToPage(-1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          scrollToPage(1);
        });

      // --- Cart refresh (sticky bar) ---
      // Subscribe to the theme's PUB_SUB cartUpdate event so the sticky bar
      // updates whenever quick-add-soul (or any other theme code) adds an item.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData) {
            updateCartBar(event.cartData);
          } else {
            scheduleCartRefresh(500);
          }
        });
      }
      // Debounce: multiple rapid calls collapse into one fetch after `delay` ms.
      var _cartRefreshTimer = null;
      function scheduleCartRefresh(delay) {
        clearTimeout(_cartRefreshTimer);
        _cartRefreshTimer = setTimeout(refreshCart, delay || 400);
      }

      function refreshCart() {
        if (typeof window.fetch !== 'function') return;
        fetch('/cart.js', {
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        })
          .then(function (res) {
            // 429 = rate-limited; back off and retry once after 2 s
            if (res.status === 429) {
              scheduleCartRefresh(2000);
              return null;
            }
            return res.text().then(function (text) {
              try {
                return JSON.parse(text);
              } catch (e) {
                return null;
              }
            });
          })
          .then(function (cart) {
            if (!cart) return;
            updateCartBar(cart);
            document.dispatchEvent(new CustomEvent('lp-products-grid:cart-updated', { detail: { cart: cart } }));
          })
          .catch(function (err) {
            if (window.console && console.warn) console.warn('[c-lp-products-grid] cart refresh failed', err);
          });
      }

      function updateCartBar(cart) {
        if (cartCountEl) {
          var label = cartCountEl.getAttribute('data-label') || 'Cart:';
          cartCountEl.textContent = label + ' ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
        }
        if (cartTotalEl) {
          cartTotalEl.textContent = moneyFormat(cart.total_price);
        }
        if (cart.item_count > 0) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var countEl = bubble.querySelector('[data-cart-count]') || bubble.querySelector('.cart-count-bubble');
            if (countEl) countEl.textContent = cart.item_count;
          }
        }
      }

      // Allow other sections / theme code to trigger a refresh
      section.addEventListener('lp-products-grid:refresh-cart', function () {
        scheduleCartRefresh(400);
      });

      // Listen to cart events dispatched by other theme scripts/apps so our
      // sticky bar stays in sync without firing an extra /cart.js request.
      document.addEventListener('cart:updated', function (e) {
        if (e.detail && e.detail.cart) updateCartBar(e.detail.cart);
      });
      document.addEventListener('cart:refresh', function () {
        scheduleCartRefresh(800);
      });

      // Defer initial load — the coalescer ensures our call doesn't compete.
      scheduleCartRefresh(3000);

      // Qty stepper +/- for cards that use the quick-add modal (use_c_quick_add + with_quantity_stepper).
      // The stepper is purely visual — on ATC click we sync its value into the
      // modal's hidden quantity input (capture phase fires before quick-add-soul.js bubble handler).
      section.addEventListener(
        'click',
        function (e) {
          // +/- buttons
          var decreaseBtn = e.target.closest('[data-ooo-qty-decrease]');
          var increaseBtn = e.target.closest('[data-ooo-qty-increase]');
          if (decreaseBtn || increaseBtn) {
            var row = (decreaseBtn || increaseBtn).closest('.collection-product-grid__qty-stepper');
            var input = row && row.querySelector('[data-ooo-qty-input]');
            if (!input) return;
            var current = parseInt(input.value, 10) || 1;
            input.value = increaseBtn ? current + 1 : Math.max(1, current - 1);
            return;
          }
          // Direct edit of the number input
          var qtyInput = e.target.closest('[data-ooo-qty-input]');
          if (qtyInput) {
            var v = parseInt(qtyInput.value, 10);
            if (isNaN(v) || v < 1) qtyInput.value = 1;
          }
        },
        false
      );

      // Capture phase: sync stepper qty → modal hidden quantity input before modal opens.
      section.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest('[data-quick-add-soul]');
          if (!btn) return;
          var productId = btn.dataset.quickAddSoul;
          if (!productId) return;
          // Find stepper input for this product within the section
          var stepperInput = section.querySelector('[data-quick-add-qty-for="' + productId + '"]');
          if (!stepperInput) return;
          var qty = Math.max(1, parseInt(stepperInput.value, 10) || 1);
          // Find the modal's quantity input and update it
          var popup = document.getElementById('QuickAddSoul-' + productId);
          if (!popup) return;
          var modalQtyInput = popup.querySelector('input[name="quantity"]');
          if (modalQtyInput) modalQtyInput.value = String(qty);
        },
        true /* capture — fires before quick-add-soul.js bubble handler */
      );
    }

    function initAll() {
      $$(ROOT_SELECTOR).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init on theme editor section load
    document.addEventListener('shopify:section:load', function (evt) {
      var el = evt.target && evt.target.querySelector ? evt.target.querySelector(ROOT_SELECTOR) : null;
      if (el) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tofu-hero-hempban"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);

    // Missouri and Illinois count down to an earlier cutoff. init() reads data-target once and
    // keeps it on the element, so when snippets/soul-geo-deadline swaps the attribute the stored
    // copy has to be refreshed by hand — the other countdowns on the site re-read theirs each tick.
    document.addEventListener('soul:geo-deadline', function () {
      var timers = document.querySelectorAll('[data-sl-countdown][data-soul-geo-clock]');
      for (var i = 0; i < timers.length; i++) {
        var next = parseTarget(timers[i].getAttribute('data-target'));
        if (next !== null) timers[i]._slTarget = next;
      }
    });
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tofu-hero-july4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tofu-hero-laborday"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tofu-hero-summer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tofu-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : String(n);
    }

    function parseTarget(value) {
      if (!value) return null;
      var t = Date.parse(value);
      if (isNaN(t)) return null;
      return t;
    }

    function tick(timer, lastDays) {
      var target = timer._slTarget;
      var now = Date.now();
      var delta = target - now;

      if (delta <= 0) {
        if (timer.dataset.pastMode === 'hide') {
          timer.hidden = true;
          timer.style.display = 'none';
          return -1;
        }
        delta = 0;
      }

      var sec = Math.floor(delta / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      var slots = timer._slSlots;
      if (slots.days) slots.days.textContent = pad(days);
      if (slots.hrs) slots.hrs.textContent = pad(hrs);
      if (slots.min) slots.min.textContent = pad(min);
      if (slots.sec) slots.sec.textContent = pad(s);

      if (days !== lastDays && timer._slSr) {
        var lbl = timer.dataset;
        var summary =
          days +
          ' ' +
          (lbl.labelDays || 'days') +
          ', ' +
          hrs +
          ' ' +
          (lbl.labelHrs || 'hours') +
          ', ' +
          min +
          ' ' +
          (lbl.labelMin || 'minutes') +
          ', ' +
          s +
          ' ' +
          (lbl.labelSec || 'seconds') +
          ' remaining';
        timer._slSr.textContent = summary;
      }

      return days;
    }

    function init(timer) {
      if (timer._slInited) return;
      timer._slInited = true;

      var target = parseTarget(timer.getAttribute('data-target'));
      if (target === null) return;
      timer._slTarget = target;

      var slots = {
        days: timer.querySelector('[data-unit="days"]'),
        hrs: timer.querySelector('[data-unit="hrs"]'),
        min: timer.querySelector('[data-unit="min"]'),
        sec: timer.querySelector('[data-unit="sec"]'),
      };
      timer._slSlots = slots;
      timer._slSr = timer.querySelector('[data-sl-countdown-sr]');

      var lastDays = -1;
      var first = tick(timer, lastDays);
      if (first === -1) return;
      lastDays = first;

      var interval = setInterval(function () {
        var d = tick(timer, lastDays);
        if (d === -1) {
          clearInterval(interval);
        } else {
          lastDays = d;
        }
      }, 1000);
    }

    function bootstrap() {
      var nodes = document.querySelectorAll('[data-sl-countdown]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  // ── Discount auto-apply (California only) ─────────────────────────────────
  // Resolves visitor's region via ipapi.co (sessionStorage cache 1h, shared
  // with the announcement bar). Only applies the discount for California
  // visitors — non-CA visitors are simply skipped, no redirect.
  // Falls back to a ?discount= URL param for per-campaign ad flexibility.
  (function () {
    var GEO_CACHE_KEY = 'sl_geo_region';
    var GEO_CACHE_TTL = 3600000; // 1 hour
    var TARGET_STATE = 'California';

    var el = document.querySelector('[data-sl-id="sl-section-lp-hero-v1"]');
    var schemaCode = el ? el.getAttribute('data-sl-discount') || '' : '';
    var params = new URLSearchParams(location.search);
    var code = params.get('discount') || schemaCode;
    if (!code || !code.trim()) return;

    console.log(
      '[SL Geo] discount code from schema:',
      schemaCode,
      '| from URL param:',
      params.get('discount'),
      '| using:',
      code
    );

    function applyDiscount() {
      console.log('[SL Geo] ✅ Applying discount:', code);
      fetch('/discount/' + encodeURIComponent(code.trim()), { redirect: 'manual' }).catch(function () {}); // silent — never interrupt the user
    }

    function handleRegion(region) {
      console.log('[SL Geo] region resolved:', region, '| target:', TARGET_STATE, '| match:', region === TARGET_STATE);
      if (region === TARGET_STATE) applyDiscount();
      else console.log('[SL Geo] ⛔ Not California — discount not applied');
    }

    // Check sessionStorage cache first
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        var age = Math.round((Date.now() - cached.ts) / 1000);
        console.log(
          '[SL Geo] cache hit — region:',
          cached.region,
          '| age:',
          age + 's',
          '| valid:',
          Date.now() - cached.ts < GEO_CACHE_TTL
        );
        if (Date.now() - cached.ts < GEO_CACHE_TTL && typeof cached.region === 'string') {
          handleRegion(cached.region);
          return;
        }
        console.log('[SL Geo] cache expired, re-fetching');
      } else {
        console.log('[SL Geo] no cache — fetching ipapi.co');
      }
    } catch (e) {
      console.warn('[SL Geo] cache read error:', e);
    }

    // Fetch region from ipapi.co
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        if (!r.ok) throw new Error('geo ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[SL Geo] ipapi.co response:', {
          country: data.country_name,
          region: data.region,
          city: data.city,
          ip: data.ip,
        });
        var region = typeof data.region === 'string' ? data.region : '';
        try {
          sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ region: region, ts: Date.now() }));
        } catch (e) {}
        handleRegion(region);
      })
      .catch(function (err) {
        console.warn('[SL Geo] ipapi.co fetch failed:', err, '— failing open, applying discount');
        applyDiscount(); // fail open — geo error shouldn't block CA users
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1100px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.querySelector('search-drawer')?.classList.contains('active')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const searchDrawer = document.querySelector('search-drawer');
      if (searchDrawer && typeof searchDrawer.close === 'function') {
        searchDrawer.close();
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent header on page load, turns solid white on scroll (all pages)
  (function () {
    function initHeaderOverHero() {
      const main = document.getElementById('MainContent');
      const sectionHeader = document.querySelector('.section-header');
      if (!main || !sectionHeader) return;
      const firstSection = main.firstElementChild;
      if (!firstSection) return;

      sectionHeader.classList.add('header-over-hero');
      sectionHeader.classList.add('shopify-section-header-sticky');

      const scrollThreshold = 20;
      function onScroll() {
        const scrolled = window.scrollY > scrollThreshold;
        sectionHeader.classList.toggle('header-scrolled', scrolled);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeaderOverHero);
    } else {
      initHeaderOverHero();
    }
  })();

  // Account dropdown toggle
  (function () {
    function initAccountDropdown() {
      const wrapper = document.querySelector('.header__account-dropdown-wrapper');
      if (!wrapper) return;
      const trigger = wrapper.querySelector('.header__account-dropdown-trigger');

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = wrapper.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });

      document.addEventListener('click', function () {
        wrapper.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      });

      wrapper.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccountDropdown);
    } else {
      initAccountDropdown();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ooo-functional-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initForm(form) {
      if (form._oooInit) return;
      form._oooInit = true;
      var btn = form.querySelector('[data-ooo-wl-submit]');
      var input = form.querySelector('input[type="email"]');
      var errEl = form.querySelector('[data-ooo-wl-error]');
      var successEl = form.parentNode.querySelector('[data-ooo-wl-success]');
      var companyId = form.getAttribute('data-company-id');
      var listId = form.getAttribute('data-list-id');
      var source = form.getAttribute('data-source') || '';

      function showError() {
        errEl.textContent = 'Hmm, that did not go through. Please try again.';
        errEl.hidden = false;
      }
      function showSuccess() {
        form.hidden = true;
        if (successEl) successEl.hidden = false;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errEl.hidden = true;
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var email = (input.value || '').trim();
        if (!email) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Joining…';

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email, properties: { signup_source: source } } } }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function (res) {
            if (res.status === 202 || res.ok) { showSuccess(); }
            else { throw new Error('klaviyo_' + res.status); }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
            showError();
          });
      });
    }

    function boot() {
      var forms = document.querySelectorAll('[data-ooo-wl-form]');
      for (var i = 0; i < forms.length; i++) initForm(forms[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
